module.exports = __webpack_public_path__ + "img/munakata.ed0f92ae.png";